import { useCallback, useEffect, useState } from 'react'
import Project from '../../../common/project'
import _data from '../../../common/utils/_data'

export function useAreas() {
  const [areas, setAreas] = useState([])
  const fetchAreas = useCallback(() => {
    _data
      .get(`${Project.liveApi}law-categorisation/get-discover-law-data`)
      .then((data) => {
        const filteredAreas = data.map((x) => x.area).filter((x) => x.image)
        setAreas(filteredAreas)
      })
      .catch((error) => console.error(error))
  }, [])
  useEffect(fetchAreas, [fetchAreas])

  return areas
}
